import {
  compose,
  getContext,
  lifecycle,
  withHandlers,
  withState,
  withPropsOnChange
} from 'recompose'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import * as serializers from 'src/charts/chart_serializer.js'
import BarChart from 'src/charts/bar-chart'
import { selectPropertyDetailsMap } from 'src/store/selectors/airDna'

const ChartTableContainer = compose(
  withState('selectedTab', 'setTab', ''),
  withState('chart', 'setChart', {}),
  withHandlers({
    // <el onClick={onChange('monthlyRevenue')} />
    onChange: ({ setTab }) => name => () => {
      setTab(name)
    }
  }),
  lifecycle({
    async componentDidMount () {
      const chartSvg = document.getElementById('air-dna-chart-svg')

      if (chartSvg) {
        const chart = new BarChart(chartSvg)
        this.props.setChart(chart)
      }

      this.props.setTab('monthlyRevenue')
    }
  }),
  getContext({
    stateKey: PropTypes.string.isRequired,
    locked: PropTypes.bool
  }),
  connect((state, { stateKey }) => {
    const { monthlyRevenue, monthlyEarnings, annualEarnings } =
      selectPropertyDetailsMap(state)[stateKey] || {}

    return {
      airDnaData: state.airDna[stateKey].data,
      percentages: {
        monthlyRevenue,
        monthlyEarnings,
        annualEarnings
      }
    }
  }),
  injectIntl,
  withPropsOnChange(
    ['selectedTab', 'airDnaData'],
    ({ airDnaData, chart, table, selectedTab, data, percentages, intl }) => {
      const percentage = percentages[selectedTab] || 1

      const preRenderCriteria = [selectedTab, airDnaData, chart.update].every(
        Boolean
      )

      const serialize = serializers[selectedTab]

      if (preRenderCriteria) {
        const data = serialize(intl, airDnaData['propertyStats'], percentage)
        chart.update(data)
      }
    }
  )
)

export default ChartTableContainer
